'use strict';

module.exports = collapse;

/* collapse(' \t\nbar \nbaz\t'); // ' bar baz ' */
function collapse(value) {
  return String(value).replace(/\s+/g, ' ');
}



//////////////////
// WEBPACK FOOTER
// ./~/collapse-white-space/index.js
// module id = 244
// module chunks = 0